import React from 'react';
import styled from 'styled-components';

const Wrapper = styled('div')`
  display: flex;
  flex-direction: row;
  gap: ${({ $gap }) => $gap};
  ${({ $wrap }) => ($wrap ? 'flex-wrap: wrap;' : '')}
`;

function Row({ children, gap = '24px', wrap, ...props }) {
  return (
    <Wrapper $gap={gap} $wrap={wrap} {...props}>
      {children}
    </Wrapper>
  );
}

export { Row };
